module.exports = __webpack_public_path__ + "static/media/friargate-2.8ecd52c1.jpg";